import React from 'react';

const Logo = ({ size = 24, variant = 'full', className = '', name = null }) => {
    const iconSize = size;
    const textSize = size * 0.9;

    const Icon = () => (
        <svg
            width={iconSize}
            height={iconSize}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="drop-shadow-[0_0_8px_rgba(var(--primary-rgb),0.3)]"
        >
            <defs>
                <linearGradient id="logo-gradient-public" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="var(--accent, #F59E0B)" />
                    <stop offset="100%" stopColor="var(--primary, #3B82F6)" />
                </linearGradient>
            </defs>
            <path
                d="M50 5L89 27.5V72.5L50 95L11 72.5V27.5L50 5Z"
                stroke="url(#logo-gradient-public)"
                strokeWidth="8"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="rgba(var(--primary-rgb), 0.05)"
            />
            <circle cx="50" cy="50" r="10" fill="url(#logo-gradient-public)" />
        </svg>
    );

    if (variant === 'icon') return <Icon />;

    return (
        <div className={`flex items-center gap-3 ${className}`} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Icon />
            <div className="flex flex-col leading-none">
                <span
                    style={{ fontSize: `${textSize}px`, letterSpacing: '-0.02em', fontWeight: 900, color: 'white', textTransform: 'uppercase' }}
                >
                    {name ? (
                        <>
                            {name.split(' ')[0]} <span style={{ color: 'var(--primary, #F59E0B)' }}>{name.split(' ').slice(1).join(' ')}</span>
                        </>
                    ) : (
                        <>
                            CONEXO <span style={{ color: 'var(--accent, #F59E0B)' }}>POS</span>
                        </>
                    )}
                </span>
            </div>
        </div>
    );
};

export default Logo;
